export default function AboutSection() {
  return (
    <section id="about" className="about-section">
      <div className="about-inner">
        {/* Left: text + values grid */}
        <div className="about-left">
          <div className="eyebrow-label">About Apex DeFi Labs Inc.</div>
          <h2>
            Building the{' '}
            <span>Infrastructure Layer</span>{' '}
            for Capital Markets
          </h2>
          <div className="about-text">
            <p>
              Apex DeFi Labs Inc. is a New York-based technology holding company operating at the intersection of{' '}
              <strong>securities compliance, blockchain infrastructure, and AI-powered investor operations</strong>{' '}
              — through its VYASA enterprise platform ecosystem.
            </p>
            <p>
              Founded by Pramod Attarde, Apex's multi-subsidiary structure allows capital, technology, and regulatory expertise to flow efficiently across geographies and product lines — from the U.S. digital securities market to India's rapidly growing capital markets sector through Vivasvat Revolutions Limited.
            </p>
            <p>
              Apex operates under multiple U.S. securities frameworks including Regulation D 506(c) and 506(b), Regulation S, Regulation CF, and Regulation A+ — positioning it as a full-spectrum compliance-first infrastructure company for the $2.1 trillion Reg D market.
            </p>
          </div>
          <div className="values-grid">
            <div className="value-cell">
              <div className="vc-title">🎯 Vision</div>
              <div className="vc-text">To be the operating system of U.S. capital markets — the platform every middle-market issuer, broker-dealer, and RIA uses to participate in the tokenized economy.</div>
            </div>
            <div className="value-cell">
              <div className="vc-title">⚖️ Compliance First</div>
              <div className="vc-text">Every product decision is made with compliance as the foundation. PII classification, SOC 2 path, and audit trail by architecture — not as an afterthought.</div>
            </div>
            <div className="value-cell">
              <div className="vc-title">🌏 Mission</div>
              <div className="vc-text">Democratize access to institutional-grade capital markets infrastructure — making the tools of Wall Street accessible to the 30,000 middle-market issuers currently underserved.</div>
            </div>
            <div className="value-cell">
              <div className="vc-title">🤝 Responsibility</div>
              <div className="vc-text">Expanding financial access across geographies and communities — with U.S. and India operations, and platforms designed to reach underserved investor and issuer communities.</div>
            </div>
          </div>
        </div>

        {/* Right: pillars */}
        <div className="about-right">
          <div className="about-pillar">
            <div className="ap-title"><div className="ap-icon">🔐</div>Regulated Infrastructure</div>
            <div className="ap-text">Built under SEC frameworks, with FINRA-registered broker-dealer partnership, a SOC 2 compliance roadmap, and 50-state blue sky integration. Not a crypto company — a regulated capital markets infrastructure provider.</div>
          </div>
          <div className="about-pillar">
            <div className="ap-title"><div className="ap-icon">🤖</div>AI-Native Architecture</div>
            <div className="ap-text">Eight domain-specific AI language models embedded across legal, tax, compliance, document generation, AML, and deal due diligence — making compliance a software problem, not an hourly billing problem.</div>
          </div>
          <div className="about-pillar">
            <div className="ap-title"><div className="ap-icon">⛓️</div>Blockchain-Ready</div>
            <div className="ap-text">ERC-1400 security token standard already in production on Polygon. DvP atomic settlement, KYC compliance oracle, multi-sig governance — the entire blockchain layer is operational, not in development.</div>
          </div>
          <div className="about-pillar">
            <div className="ap-title"><div className="ap-icon">🌐</div>Multi-Jurisdiction</div>
            <div className="ap-text">U.S. parent with three operational subsidiaries across securities, AI technology, and India operations under MCA and FEMA frameworks — built for the global tokenized securities market from day one.</div>
          </div>
          <div className="about-pillar">
            <div className="ap-title"><div className="ap-icon">🏆</div>Category Leadership</div>
            <div className="ap-text">VYASA occupies a clear white space — the only platform combining tokenized issuance, a native K-1 engine, 8 AI compliance SLMs, and purpose-built portals for CPAs, counsel, and broker-dealers at a middle-market price point.</div>
          </div>
        </div>
      </div>
    </section>
  );
}
